import { useEffect, useState } from 'react'
import { Box, Card, Typography, useMediaQuery } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { CardFiltration, FiltrationTitle } from './style'
import { FormBlock } from '../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { PureLightTheme } from '../../../styles/theme'
import { TEXT_FILTER_DEBOUNCE_MS } from '../../../consts/filtration'

const normalizeStringFilter = (value: unknown): string | undefined => {
  const normalized = String(value ?? '').trim()
  if (!normalized) return undefined
  return normalized
}

export const SocialOrdersFiltration = () => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const { watch } = useFormContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const search = watch('search')
  const focus = watch('focus')
  const [debouncedSearch, setDebouncedSearch] = useState(search)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedSearch(search)
    }, TEXT_FILTER_DEBOUNCE_MS)

    return () => window.clearTimeout(timeoutId)
  }, [search])

  useEffect(() => {
    const nextParams = new URLSearchParams(searchParams)
    const normalizedQuery = normalizeStringFilter(debouncedSearch)
    const focusValues = Array.isArray(focus)
      ? focus.map((v) => String(v).trim()).filter(Boolean)
      : []

    if (normalizedQuery) {
      nextParams.set('query', normalizedQuery)
    } else {
      nextParams.delete('query')
    }

    nextParams.delete('focus[]')
    focusValues.forEach((value) => {
      nextParams.append('focus[]', value)
    })

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams, { replace: true })
    }
  }, [debouncedSearch, focus, searchParams, setSearchParams])

  return (
    <Card variant="primaryCard" sx={CardFiltration}>
      {!isMobile && (
        <Box mb={{ md: 2.5 }}>
          <FormBlock formFieldConfig={getFormConfig('search')} />
        </Box>
      )}
      <Typography variant="h4" sx={FiltrationTitle}>Направленность соцзаказов:</Typography>
      <FormBlock formFieldConfig={getFormConfig('socialOrderFocus')} />
    </Card>
  )
}
